import { Headline } from '../headline.model';


export class CompanyShortInterest {
  id: number;
  floatQuantity: number;
  shortInterestQuantity: number;
  shortInterestPercentage: number;
  benchmarkRate: number;
  utilization: number | string;
  daysToCover: number;
  raDaysToCover: number;
  updated: string;
  isOpen: boolean;
  headlines?: Array<Headline>;
  ticker?: string;
  name?: string;
  companyId?: number;
  marketCap?: number;
  marketCapInUsd?: number;
  currencyCode?: string;
  lastTrade?: number;
  lastTradeInUsd?: boolean;
  percentChange?: number;
  hardToBorrow: boolean;

  constructor(data: CompanyShortInterest = {} as CompanyShortInterest) {
    this.id = data.id || null;
    this.floatQuantity = data.floatQuantity || null;
    this.shortInterestQuantity = data.shortInterestQuantity || null;
    this.shortInterestPercentage = data.shortInterestPercentage || null;
    this.benchmarkRate = data.benchmarkRate || null;
    this.utilization = data.utilization || null;
    this.daysToCover = data.daysToCover || null;
    this.raDaysToCover = data.raDaysToCover || null;
    this.updated = data.updated || null;
    this.isOpen = data.isOpen || false;
    this.headlines = data.headlines || [];
    this.ticker = data.ticker || null;
    this.name = data.name || null;
    this.companyId = data.companyId || null;
    this.marketCap = data.marketCap || null;
    this.marketCapInUsd = data.marketCapInUsd || null;
    this.currencyCode = data.currencyCode || null;
    this.lastTrade = data.lastTrade || null;
    this.lastTradeInUsd = data.lastTradeInUsd || null;
    this.percentChange = data.percentChange || null;
    this.hardToBorrow = data.hardToBorrow || null;
  }
}
